module.exports = __webpack_public_path__ + "static/gallery_west_street_5_thumb-0897b491fbedf135f07eae46dc228394.jpg";